import styled from 'styled-components';

const NextText = styled.span`
    font-size: 1em;
    font-weight: 500;
    text-align: center;
    display: block;
    margin-bottom: 0.7em;
`;

export default NextText;